<div class="top">
  <div class="heading">
    <span>Update Role</span>
  </div>
  <i class="material-icons text-danger" role="button" (click)="closeModal()">
    close
  </i>
</div>

<div class="form-wrapper">
  <form [formGroup]="roleManagementForm" (ngSubmit)="openConfirmModal()">
    <div class="form-fields">
      <div class="field">
        <label for="name">Role Name</label>
        <input id="name" type="text" formControlName="name" class="form-control" placeholder="e.g., Admin" />

      </div>

      <div class="field">
        <label for="name">Description</label>
        <input id="description" type="text" formControlName="description" maxlength="120" class="form-control"
          placeholder="e.g., Admin with full access" />

      </div>

      <div class="field">
        <label for="privileges">Privileges</label>

        @if(!privileges){
        <ngx-skeleton-loader class="input-skeleton"></ngx-skeleton-loader>
        }
        @else{
        <ng-select #ngPrivilegeSelect [items]="privileges" [multiple]="true" [closeOnSelect]="false" [searchable]="true"
          [hideSelected]="false" bindLabel="permission" bindValue="privilegeId" placeholder="Select option"
          formControlName="privileges" class="ng-select control role-select">

          <ng-template ng-header-tmp>
            <span role="button" (click)="selectAll(ngPrivilegeSelect, 'privileges')">
              Select All
            </span>
          </ng-template>

          <ng-template ng-option-tmp let-item="item">
            <label class="option-container" (click)="toggleSelection(item, isSelected(item), $event)">
              <input type="checkbox" [checked]="isSelected(item)" />
              <span>{{ item.permission }}</span>
            </label>
          </ng-template>

        </ng-select>
        }
      </div>
    </div>

    <div class="modal-actions-wrapper">
      <button type="submit" class="custom-btn-primary w-100" [disabled]="
          !roleManagementForm.dirty || roleManagementForm.invalid
        ">
        <ng-container *ngIf="!isSubmitting; else loadingTemplate">
          <span>Save</span>
        </ng-container>
        <ng-template #loadingTemplate>
          <span>Saving...</span>
        </ng-template>
      </button>
    </div>
  </form>
</div>